import {AppointmentRangeReq} from './planned-appointment.contract';
import {DateRange} from '../../../services/date-range.service';

export class PatternOverrideCreateReq extends AppointmentRangeReq{
    appointmentId:number;
    onDate:string;
    duration:number;

    constructor(appointment:number, onDate:Date, duration:number, range:DateRange) {
        super(range);
        this.appointmentId = appointment;
        onDate.setUTCHours(0,0,0)
        this.onDate = onDate.toISOString();
        this.duration = duration
    }
}